import i18n from 'i18n-js';

import en from './LangTranslations/en.json';
import cs from './LangTranslations/cs.json';
i18n.fallbacks = true;
i18n.translations = { cs, en}; 

export default i18n;